import video from "Assets/img/InvestorPageAssets/All Team_1.mp4";
import ContainedButton from "Components/HomeV2/Buttons/Contained";
import SimpleNavbar from "Components/SimpleNavbar";
import { useEffect, useState } from "react";
declare global {
    interface Window {
        hbspt: any;
    }
}

const LeadCarePage = () => {

    const [playVideo, setPlayVideo] = useState(false);
    const [isFormOpen, setIsFormOpen] = useState(false);

    const toggleVideoPlay = (playVideo: boolean) => {
        const videoElement = document.querySelector('video');
        if (videoElement) {
            if (playVideo) {
                videoElement.play();
                setPlayVideo(true);
            } else {
                videoElement.pause();
                setPlayVideo(false);
            }
        }
    }

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://js.hsforms.net/forms/v2.js';
        script.async = true;

        script.onload = () => {
            if (window.hbspt) {
                window.hbspt.forms.create({
                    portalId: '6045774',
                    formId: '6d3311b7-f1dd-4ff9-b019-82d3dca1dd42',
                    region: 'na1',
                    target: '#hubspotForm'
                });
                console.log(window.hbspt)
            }
        };

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);
    return (
        <main id="home" className="h-full w-full ">
            {/* <section className="bg-black w-full h-20 border-b border-b-gray-300 border-opacity-20 flex items-center justify-center">
                <img src={require('Assets/logo.png')} alt="Salesmrkt" height={30} width={160} />
            </section> */}

            <section className="bg-[#D8EFFF] text-black flex flex-col h-full w-full justify-center items-center ">
                <div className="flex flex-col h-full w-full justify-center items-center px-5">
                    <div className="text-md md:text-xl font-bold mb-6 text-center sm:text-left w-fit bg-white/95 mt-16 px-8 py-1 rounded-full ">
                        Video Production Companies Above $10k/month
                    </div>
                    <div className="text-3xl md:text-7xl font-bold mb-8 text-center">
                        Close 10-20 New Clients<br />
                        Every 30 Days                </div>
                    <div className="text-sm md:text-md mb-3 text-center sm:text-left font-bold">
                        Step 1: watch the video below and see how this offer works
                    </div>
                    <div className=" items-center justify-center flex rounded-2xl relative overflow-hidden h-auto mb-5 w-full max-w-[1200px]">
                        <video src={video} className="h-full w-full " controls={playVideo} onPause={() => toggleVideoPlay(false)}

                        >
                        </video>
                        {
                            !playVideo ? (
                                <div className="absolute z-[1] bg-black/40 w-full  h-full flex items-center justify-center mx-auto my-auto">
                                    <div className="max-w-[200px] lg:max-w-[400px] flex items-center justify-center " onClick={() => toggleVideoPlay(true)} >
                                        <ContainedButton size="sm">
                                            <div className="flex items-center gap-2 ">
                                                <svg
                                                    className="md:w-5 md:h-6 w-3   h-3"
                                                    viewBox="0 0 19 22"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        d="M0 20.3646V1.269C0 0.445639 0.898116 -0.0630229 1.60426 0.360401L17.5173 9.90237C18.2032 10.3137 18.2035 11.3076 17.5178 11.7193L1.60474 21.2729C0.898614 21.6969 0 21.1882 0 20.3646Z"
                                                        fill="black"
                                                    />
                                                </svg>
                                                <span className="text-sm md:text-base">Play video</span>
                                            </div>
                                        </ContainedButton>
                                    </div>
                                </div>

                            ) : null
                        }
                    </div>
                    <div className="text-sm md:text-md mb-5 text-center sm:text-left font-bold">
                        Step 2: book a free demo of our pay-per-close offer by clicking the button below
                    </div>
                    <button
                        // onClick={() => setIsFormOpen(true)} 
                        className="bg-brand-green text-black flex  mb-5 justify-center items-center text-xl md:text-3xl font-bold h-24 rounded-full px-24 border border-brand-green hover:border-black hover:bg-transparent transition-all duration-200 ease-in-out py-5 whitespace-nowrap">
                        Book a Demo
                    </button>
                    <div className="mb-5 text-center uppercase sm:text-left font-light">
                        Pay-per-close offer ending soon
                    </div>
                    {
                        isFormOpen ? (
                            <div className="bg-black/40 fixed top-0 left-0 w-full h-full flex-col justify-center items-center">
                                <div id="hubspotForm" className="bg-white max-w-[500px] mx-auto"></div>
                                {/* <div className="relative">
                        <div className="absolute bg-black h-20 w-[300px] bottom-0 left-0">

                        </div>
                    </div> */}
                            </div>
                        ) : null
                    }
                </div>
                <SimpleNavbar />
            </section>
        </main>
    );
};

export default LeadCarePage;
